/**
*
* StepOne
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Transition } from 'react-transition-group';

import { Button, CopyTextBox, AnchorLink } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import enhanceWithChildrenHeight from 'hocs/enhanceWithChildrenHeight';

import {
  GrowingWrapper,
  VerticalSeparator,
} from './styles';
import messages from './messages';

const EnhancedGrowingWrapper = enhanceWithChildrenHeight(GrowingWrapper);

const StepOne = ({ active, instantDisplay, next }) => (
  <Transition
    in={active}
    timeout={300}
    unmountOnExit
  >
    {(state) => (
      <EnhancedGrowingWrapper transitionState={state} instantDisplay={instantDisplay}>
        <VerticalSeparator>
          <FormattedMessage
            {...messages.sprCliInstallText}
            values={{
              npmDocLink: <AnchorLink iconRight iconSize={18} icon="open_in_new" href="https://www.npmjs.com/" target="_blank" >{messages.npm} </AnchorLink>,
              brontePluginLink: <AnchorLink iconRight iconSize={18} icon="open_in_new" href={messages.brontePluginDocsLink} target="_blank" > {messages.brontePluginDocsLink} </AnchorLink>,
            }}
          />
        </VerticalSeparator>
        <VerticalSeparator>
          <CopyTextBox
            grey
            textType="code"
            value={messages.npmInstallCode}
            notificationLabel={intl.formatMessage(messages.copied)}
          />
        </VerticalSeparator>
        <Button primary onClick={next}>
          <FormattedMessage {...messages.nextStep} />
        </Button>
      </EnhancedGrowingWrapper>
    )}
  </Transition>
);

StepOne.propTypes = {
  active: PropTypes.bool,
  instantDisplay: PropTypes.bool,
  next: PropTypes.func,
};

export default StepOne;
